import { createFileRoute } from '@tanstack/react-router'
import { ApiDocsViewer } from '@/components/ApiDocsViewer'
import { useApiQuery } from '@/api/ApiQueryServiceProvider'
import conexIcon from '@/assets/conex-icon.png'

// @ts-ignore - Route type generation issue in Jest
export const Route = createFileRoute('/api-docs/conex')({
  staticData: {
    title: 'ConEx API Docs',
    isSecured: true,
  },
  component: ConExApiDocsPage,
})

function ConExApiDocsPage() {
  const { data, isLoading, isError, error, refetch } = useApiQuery<{
    message: string
    content: object
  }>('getConexApiSpec', {}, {})

  const spec = (data?.content ?? null) as object | null
  const notFound = !isLoading && !isError && data != null && !spec

  return (
    <div className="-mx-6 -mt-6 h-[calc(100vh-64px)] overflow-hidden">
      <ApiDocsViewer
        title="ConEx API Reference"
        logo={conexIcon}
        spec={spec}
        loading={isLoading}
        error={isError ? (error?.message ?? 'Failed to load spec') : null}
        notFound={notFound}
        onReload={() => { refetch() }}
      />
    </div>
  )
}
